// abstractions for dealing with workflows labels and
// connecting them to the Markdown editor
export function fromSteps(steps) {
    const labels = [];
    if (!steps) {
        return labels;
    }
    Object.values(steps).forEach((step) => {
        const stepType = step.type;
        if (step.label) {
            const isInput = ["data_input", "data_collection_input", "parameter_input"].indexOf(stepType) >= 0;
            if (isInput) {
                labels.push({ type: "input", label: step.label });
            }
            else {
                labels.push({ type: "step", label: step.label });
            }
        }
        step.workflow_outputs.forEach((workflowOutput) => {
            if (workflowOutput.label) {
                labels.push({ type: "output", label: workflowOutput.label });
            }
        });
    });
    return labels;
}
